export const it = {
    ra: {
        configurable: {
            customize: 'Customize'
        },
        action: {
          add_filter: 'Aggiungi un filtro',
          add: 'Aggiungi',
          back: 'Indietro',
          bulk_actions: '%{smart_count} selezionati',
          cancel: 'Annulla',
          clear_input_value: 'Svuota il modulo',
          clone: 'Duplica',
          confirm: 'Conferma',
          create: 'Crea',
          'delete': 'Cancella',
          edit: 'Modifica',
          'export': 'Esporta',
          list: 'Elenco',
          refresh: 'Aggiorna',
          remove_filter: 'Rimuovi questo filtro',
          remove_all_filters: 'Rimuovi tutti filtri',
          remove: 'Remove',
          save: 'Salva',
          search: 'Ricerca',
          show: 'Mostra',
          sort: 'Ordina',
          undo: 'Annulla',
          expand: 'Espandi',
          close: 'Chiudi',
          unselect: 'Unselect'
        },
        'boolean': {
          true: 'Si',
          false: 'No',
          null: 'Nullo'
        },
        page: {
          create: 'Aggiungi %{name}',
          dashboard: 'Cruscotto',
          edit: '%{name} %{id}',
          error: 'Qualcosa non ha funzionato',
          list: 'Lista %{name}',
          loading: 'Caricamento in corso',
          not_found: 'Non trovato',
          show: '%{name} %{id}'
        },
        input: {
          file: {
            upload_several: 'Trascina i files da caricare, oppure clicca per selezionare.',
            upload_single: 'Trascina il file da caricare, oppure clicca per selezionarlo.'
          },
          image: {
            upload_several: 'Trascina le immagini da caricare, oppure clicca per selezionarle.',
            upload_single: 'Trascina l\'immagine da caricare, oppure clicca per selezionarla.'
          },
          references: {
            all_missing: 'Impossibile trovare i riferimenti associati.',
            many_missing: 'Almeno uno dei riferimenti associati non sembra più disponibile.',
            single_missing: 'Il riferimento associato non sembra più disponibile.'
          }
        },
        message: {
          about: 'Informazioni',
          are_you_sure: 'Sei sicuro ?',
          bulk_delete_content: 'Sei sicuro di voler cancellare questo %{name}? |||| Sei sicuro di voler eliminare questi %{smart_count}?',
          bulk_delete_title: 'Delete %{name} |||| Delete %{smart_count} %{name} items',
          delete_content: 'Are you sure you want to delete this item?',
          delete_title: 'Cancella %{name} #%{id}',
          details: 'Dettagli',
          error: 'Un errore locale è occorso e la tua richiesta non è stata completata.',
          invalid_form: 'Il modulo non è valido. Si prega di verificare la presenza di errori.',
          loading: 'La pagina si sta caricando, solo un momento per favore',
          no: 'No',
          not_found: 'Hai inserito un URL errato, oppure hai cliccato un link errato',
          yes: 'Si'
        },
        navigation: {
          no_results: 'Nessun risultato trovato',
          no_more_results: 'La pagina numero %{page} è fuori dell\'intervallo. Prova la pagina precedente.',
          page_out_of_boundaries: 'Il numero di pagina %{page} è fuori dei limiti',
          page_out_from_end: 'Fine della paginazione',
          page_out_from_begin: 'Il numero di pagina deve essere maggiore di 1',
          page_range_info: '%{offsetBegin}-%{offsetEnd} di %{total}',
          page_rows_per_page: 'Righe per pagina',
          next: 'Successivo',
          prev: 'Precedente'
        },
        auth: {
          user_menu: 'Profile',
          username: 'Nome utente',
          password: 'Password',
          sign_in: 'Login',
          sign_in_error: 'Autenticazione fallita, riprovare.',
          logout: 'Disconnessione'
        },
        notification: {
          updated: 'Record aggiornato |||| %{smart_count} records aggiornati',
          created: 'Record creato',
          deleted: 'Record eliminato |||| %{smart_count} records eliminati',
          bad_item: 'Record errato',
          item_doesnt_exist: 'Record inesistente',
          http_error: 'Errore di comunicazione con il server dati',
          data_provider_error: 'Errore del data provider. Controlla la console per i dettagli.',
          canceled: 'Azione annullata',
          logged_out: 'La sessione è scaduta. Effettua nuovamente l\'accesso.'
        },
        validation: {
          required: 'Campo obbligatorio',
          minLength: 'Deve essere lungo %{min} caratteri almeno',
          maxLength: 'Deve essere lungo %{max} caratteri al massimo',
          minValue: 'Deve essere almeno %{min}',
          maxValue: 'Deve essere al massimo %{max}',
          number: 'Deve essere un numero',
          email: 'Deve essere un valido indirizzo email',
          oneOf: 'Deve essere uno di: %{options}',
          regex: 'Deve rispettare il formato (espressione regolare): %{pattern}'
        },
        sort: {
            ASC: "Ascending"
        }
      },
    resources: {
        devices: {
            name: 'Apparato |||| Apparati',
            fields: {
                serial_number_tim: 'Serial Number TIM',
                serial_number_forn: 'Serial Number Fornitore',
                mac_address: 'MAC Address',
                workrequestid: 'Id Work Request',
                createdAt: 'Creato il',
                createdAt_gte: 'Creato dopo il',
                createdAt_lte: 'Creato prima del',
                updatedAt: 'Aggiornato il',
                createdBy: 'Creato da',
                updatedBy: 'Aggiornato da',
                impianto: 'Telefonico Impianto',
                resource_id: 'Identificativo Resource',
                impianto_regman: 'Telefonico Impianto Regman',
                codice_impresa_name: 'Codice Impresa Utilizzo',
                cod_terr_sap: 'Codice Sap Magazzino',
                cod_terr_sap_mos: 'Codice Magazzino Orig',
                codice_magazzino: 'Codice Magazzino',
                divisione: 'Territorio',
                num_consegna: 'Numero consegna',
                num_consegna_orig: 'Numero consegna Orig',
                cod_nmu: 'Codice NMU',
                cod_stato_uso: {
                    codice: 'Partita del materiale'
                },
                cod_proj: 'Codice progetto',
                client_type: 'Tipo cliente',
                associated_at: 'Associato il',
                associated_by: 'Associato da',
                approved_at: 'Approvato il',
                approved_by: 'Approvato da',
                validated_at: 'Validato il',
                validated_by: 'Validato da',
                closed_at: 'Chiuso il',
                closed_by: 'Chiuso da',
                associated_at_gte: 'Associato dopo il',
                associated_at_lte: 'Associato prima del',
                sent_to_sap: 'Inviato a SAP',
                sent_to_sap_gte: 'Scaricato dopo il',
                sent_to_sap_lte: 'Scaricato prima del',
                validated_at_gte: 'Validato dopo il',
                validated_at_lte: 'Validato prima del',
                status: {
                    codice: 'Stato',
                    descrizione: 'Stato'
                },
                tipo_task: 'Tipo',
                wr_prodotti: 'Lavorazione con Prodotti',
                causale: {
                    codice: 'Causale',
                    descrizione: 'Causale'
                },
                anomalia: {
                    codice: 'Anomalia',
                    descrizione: 'Anomalia'
                },
                reverse: {
                    codice: 'Reverse',
                    descrizione: 'Reverse'
                },
                status_regman: {
                    codice: 'Stato Regman',
                    descrizione: 'Stato Regman'
                },
                area: 'Area',
                tipo_inserimento: 'Tipo inserimento',
                attachment_flag: 'File Allegato',
                note: 'Note',
                serial_number_cpe: 'Serial Number InfoRegman',
                lista_NMU: 'Lista NMU WR',
                data_completamento_wr: 'Data Completamento WR',
                data_completamento_wr_gte: 'WR Completata dopo il',
                data_completamento_wr_lte: 'WR Completata prima del',
                descrizione_impresa: 'Descrizione Impresa Utilizzo',
                check_NMU: 'Check NMU',
                codice_isp: 'Codice ISP',
                flag_olo: 'Flag OLO',
                tsys: 'TSYS',
                check_u0009t: 'Check U0009T',
                importo_u0009t: 'Importo U0009T',
                progetto_con_scarico: 'Progetto con scarico',
                tipo_nmu: 'Tipo NMU Associata',
                codice_riscontro: 'Codice Riscontro',
                cod_gruppo_tec: 'Codice Gruppo Tecnico',
                tipo_famiglia: 'Tipo Famiglia',
                causale_addebito: {
                    codice: 'Causale Addebito',
                    descrizione: 'Causale Addebito'
                },
                note_addebito: 'Note Addebito',
                post_delivery: 'Post Delivery',
                wr_collaudo_one: 'WR CollaudoOne',
                impianto_collaudo_one: 'Impianto CollaudoOne',
                data_collaudo_one: 'Data CollaudoOne',
                data_collaudo_one_gte: 'Data CollaudoOne dopo il',
                data_collaudo_one_lte: 'Data CollaudoOne prima del',
                status_collaudo_one: 'Stato CollaudoOne',
                equivalenza_prod_applicabile: 'Equivalenza Prod Applicabile',
                contatore: 'Contatore',
                blinda_scarico_mat: 'Blinda Scarico Materiale',
                proprieta_materiale: 'Proprietà Materiale WR',
                one_step: 'One Step'
            },
        },
        devices_daesaminare: {
            name: 'Apparato Lato Impresa |||| Apparati Lato Impresa',
            fields: {
                serial_number_tim: 'Serial Number TIM',
                serial_number_forn: 'Serial Number Fornitore',
                mac_address: 'MAC Address',
                workrequestid: 'Id Work Request',
                createdAt: 'Creato il',
                createdAt_gte: 'Creato dopo il',
                createdAt_lte: 'Creato prima del',
                updatedAt: 'Aggiornato il',
                createdBy: 'Creato da',
                updatedBy: 'Aggiornato da',
                impianto: 'Telefonico Impianto',
                resource_id: 'Identificativo Resource',
                impianto_regman: 'Telefonico Impianto Regman',
                codice_impresa_name: 'Codice Impresa Utilizzo',
                cod_terr_sap: 'Codice Sap Magazzino',
                cod_terr_sap_mos: 'Codice Magazzino Orig',
                codice_magazzino: 'Codice Magazzino',
                divisione: 'Territorio',
                num_consegna: 'Numero consegna',
                num_consegna_orig: 'Numero consegna Orig',
                cod_nmu: 'Codice NMU',
                cod_stato_uso: {
                    codice: 'Partita del materiale'
                },
                cod_proj: 'Codice progetto',
                client_type: 'Tipo cliente',
                associated_at: 'Associato il',
                associated_by: 'Associato da',
                approved_at: 'Approvato il',
                approved_by: 'Approvato da',
                validated_at: 'Validato il',
                validated_by: 'Validato da',
                validated_at_gte: 'Validato dopo il',
                validated_at_lte: 'Validato prima del',
                associated_at_gte: 'Associato dopo il',
                associated_at_lte: 'Associato prima del',
                sent_to_sap: 'Inviato a SAP',
                sent_to_sap_gte: 'Scaricato dopo il',
                sent_to_sap_lte: 'Scaricato prima del',
                status: {
                    codice: 'Stato',
                    descrizione: 'Stato'
                },
                tipo_task: 'Tipo',
                wr_prodotti: 'Lavorazione con Prodotti',
                causale: {
                    codice: 'Causale',
                    descrizione: 'Causale'
                },
                anomalia: {
                    codice: 'Anomalia',
                    descrizione: 'Anomalia'
                },
                reverse: {
                    codice: 'Reverse',
                    descrizione: 'Reverse'
                },
                status_regman: {
                    codice: 'Stato Regman',
                    descrizione: 'Stato Regman'
                },
                area: 'Area',
                tipo_inserimento: 'Tipo inserimento',
                attachment_flag: 'File Allegato',
                serial_number_cpe: 'Serial Number InfoRegman',
                codice_isp: 'Codice ISP',
                flag_olo: 'Flag OLO',
                tsys: 'TSYS',
                check_u0009t: 'Check U0009T',
                importo_u0009t: 'Importo U0009T',
                data_completamento_wr: 'Data Completamento WR',
                data_completamento_wr_gte: 'WR Completata dopo il',
                data_completamento_wr_lte: 'WR Completata prima del',
                progetto_con_scarico: 'Progetto con scarico',
                tipo_nmu: 'Tipo NMU Associata',
                codice_riscontro: 'Codice Riscontro',
                cod_gruppo_tec: 'Codice Gruppo Tecnico',
                tipo_famiglia: 'Tipo Famiglia',
                causale_addebito: {
                    codice: 'Causale Addebito',
                    descrizione: 'Causale Addebito'
                },
                wr_collaudo_one: 'WR CollaudoOne',
                impianto_collaudo_one: 'Impianto CollaudoOne',
                data_collaudo_one: 'Data CollaudoOne',
                data_collaudo_gte: 'Data CollaudoOne dopo il',
                data_collaudo_lte: 'Data CollaudoOne prima del',
                status_collaudo_one: 'Stato CollaudoOne',
                equivalenza_prod_applicabile: 'Equivalenza Prod Applicabile',
                contatore: 'Contatore',
                blinda_scarico_mat: 'Blinda Scarico Materiale',
                proprieta_materiale: 'Proprietà Materiale WR',
                one_step: 'One Step'
            },
        },
        devicesScaricato: {
            name: 'Apparato Scaricato |||| Apparati Scaricati',
            fields: {
                serial_number_tim: 'Serial Number TIM',
                serial_number_forn: 'Serial Number Fornitore',
                mac_address: 'MAC Address',
                workrequestid: 'Id Work Request',
                createdAt: 'Creato il',
                createdAt_gte: 'Creato dopo il',
                createdAt_lte: 'Creato prima del',
                updatedAt: 'Aggiornato il',
                createdBy: 'Creato da',
                updatedBy: 'Aggiornato da',
                impianto: 'Telefonico Impianto',
                resource_id: 'Identificativo Resource',
                impianto_regman: 'Telefonico Impianto Regman',
                codice_impresa_name: 'Codice Impresa Utilizzo',
                cod_terr_sap: 'Codice Sap Magazzino',
                cod_terr_sap_mos: 'Codice Magazzino Orig',
                codice_magazzino: 'Codice Magazzino',
                divisione: 'Territorio',
                num_consegna: 'Numero consegna',
                num_consegna_orig: 'Numero consegna Orig',
                cod_nmu: 'Codice NMU',
                cod_stato_uso: {
                    codice: 'Partita del materiale'
                },
                cod_proj: 'Codice progetto',
                client_type: 'Tipo cliente',
                associated_at: 'Associato il',
                associated_by: 'Associato da',
                approved_at: 'Approvato il',
                approved_by: 'Approvato da',
                validated_at: 'Validato il',
                validated_by: 'Validato da',
                validated_at_gte: 'Validato dopo il',
                validated_at_lte: 'Validato prima del',
                associated_at_gte: 'Associato dopo il',
                associated_at_lte: 'Associato prima del',
                sent_to_sap: 'Inviato a SAP',
                sent_to_sap_gte: 'Scaricato dopo il',
                sent_to_sap_lte: 'Scaricato prima del',
                rp_sent_to_sap_gte: 'RP_NMU: Scaricato dopo il',
                rp_sent_to_sap_lte: 'RP_NMU: Scaricato prima del',
                status: {
                    codice: 'Stato',
                    descrizione: 'Stato'
                },
                tipo_task: 'Tipo',
                wr_prodotti: 'Lavorazione con Prodotti',
                causale: {
                    codice: 'Causale',
                    descrizione: 'Causale'
                },
                anomalia: {
                    codice: 'Anomalia',
                    descrizione: 'Anomalia'
                },
                reverse: {
                    codice: 'Reverse',
                    descrizione: 'Reverse'
                },
                status_regman: {
                    codice: 'Stato Regman',
                    descrizione: 'Stato Regman'
                },
                area: 'Area',
                tipo_inserimento: 'Tipo inserimento',
                serial_number_cpe: 'Serial Number InfoRegman',
                codice_isp: 'Codice ISP',
                flag_olo: 'Flag OLO',
                tsys: 'TSYS',
                check_u0009t: 'Check U0009T',
                importo_u0009t: 'Importo U0009T',
                data_completamento_wr: 'Data Completamento WR',
                data_completamento_wr_gte: 'WR Completata dopo il',
                data_completamento_wr_lte: 'WR Completata prima del',
                progetto_con_scarico: 'Progetto con scarico',
                tipo_nmu: 'Tipo NMU Associata',
                codice_riscontro: 'Codice Riscontro',
                cod_gruppo_tec: 'Codice Gruppo Tecnico',
                tipo_famiglia: 'Tipo Famiglia',
                causale_addebito: {
                    codice: 'Causale Addebito',
                    descrizione: 'Causale Addebito'
                },
                attachment_flag: 'File Allegato',
                wr_collaudo_one: 'WR CollaudoOne',
                impianto_collaudo_one: 'Impianto CollaudoOne',
                data_collaudo_one: 'Data CollaudoOne',
                data_collaudo_gte: 'Data CollaudoOne dopo il',
                data_collaudo_lte: 'Data CollaudoOne prima del',
                status_collaudo_one: 'Stato CollaudoOne',
                equivalenza_prod_applicabile: 'Equivalenza Prod Applicabile',
                contatore: 'Contatore',
                blinda_scarico_mat: 'Blinda Scarico Materiale',
                proprieta_materiale: 'Proprietà Materiale WR',
                one_step: 'One Step'
            },
        },
        devicelogs: {
            name: 'Registro operazione |||| Registro operazioni',
            fields: {
                serial_number_tim: 'Serial Number TIM',
                serial_number_forn: 'Serial Number Fornitore',
                operation: 'Operazione',
                mac_address: 'MAC Address',
                workrequestid: 'Id Work Request',
                createdAt: 'Creato il',
                createdAt_gte: 'Creato dopo il',
                createdAt_lte: 'Creato prima del',
                updatedAt: 'Aggiornato il',
                _updatedAt: 'Aggiornato il',
                createdBy: 'Creato da',
                updatedBy: 'Aggiornato da',
                impianto: 'Telefonico Impianto',
                impianto_regman: 'Telefonico Impianto Regman',
                codice_impresa_name: 'Codice Impresa Utilizzo',
                cod_terr_sap: 'Codice Sap Magazzino',
                cod_terr_sap_mos: 'Codice Magazzino Orig',
                num_consegna: 'Numero consegna',
                num_consegna_orig: 'Numero consegna Orig',
                cod_nmu: 'CODICE NMU',
                cod_stato_uso: 'Partita del materiale',
                cod_proj: 'Codice progetto',
                client_type: 'Tipo cliente',
                associated_at: 'Associato il',
                associated_by: 'Associato da',
                approved_at: 'Approvato il',
                approved_by: 'Approvato da',
                associated_at_gte: 'Associato dopo il',
                associated_at_lte: 'Associato prima del',
                sent_to_sap: 'Inviato a SAP',
                status: {
                    codice: 'Stato',
                    descrizione: 'Stato'
                },
                tipo_task: 'Tipo',
                wr_prodotti: 'Lavorazione con Prodotti',
                causale: 'Causale',
                anomalia: {
                    codice: 'Anomalia',
                    descrizione: 'Anomalia'
                },
                data_completamento_wr: 'Data Completamento WR',
                data_completamento_wr_gte: 'WR Completata dopo il',
                data_completamento_wr_lte: 'WR Completata prima del',
                codice_riscontro: 'Codice Riscontro',
                cod_gruppo_tec: 'Codice Gruppo Tecnico',
                tipo_famiglia: 'Tipo Famiglia',
                wr_collaudo_one: 'WR CollaudoOne',
                impianto_collaudo_one: 'Impianto CollaudoOne',
                data_collaudo_one: 'Data CollaudoOne',
                data_collaudo_gte: 'Data CollaudoOne dopo il',
                data_collaudo_lte: 'Data CollaudoOne prima del',
                status_collaudo_one: 'Stato CollaudoOne',
                equivalenza_prod_applicabile: 'Equivalenza Prod Applicabile',
                contatore: 'Contatore',
                blinda_scarico_mat: 'Blinda Scarico Materiale',
                proprieta_materiale: 'Proprietà Materiale WR',
                one_step: 'One Step'
            },
        },
        magmois: {
            name: 'Magazzino Moi |||| Blocca / Sblocca Scarico',
            fields: {
                // cod_terr_sap: '',
                codice_impresa_desc: 'Denominazione Impresa',
                codice_impresa_sap: 'Codice SAP Impresa',
                // desc_indirizzo: '',
                // val_cap: '',
                // desc_localita: '',
                // desc_prov: '',
                // nome_naz: '',
                num_telefono: 'Telefono',
                num_fax: 'Fax',
                e_mail: 'Email',
                flag_valid: 'Valido',
                desc_note: 'Note',
                // data_agg_sistema: '',
                flag_tipo_terr_sap: 'Tipo SAP',
                classe_di_trasporto: 'Classe di Transporto',
                disattivato_il: "Bloccato / Sbloccato il",
                disattivato_il_gte: 'Bloccato / Sbloccato dopo il',
                disattivato_il_lte: 'Bloccato / Sbloccato prima del',
                disattivado_da: "Bloccato / Sbloccato da",
                flag_disattivazione: "Bloccato"
            },
        },
        nomenclatores: {
            name: 'Nomenclatura |||| Nomenclature',
            fields: {
                cod_nmu: 'Codice NMU',
                desc_nmu: 'Descrizione NMU',
                cod_gruppo_tec: 'Codice Gruppo Tecnico',
                tipo_propr_materiale: 'Tipo Materiale',
                divresp: 'Divisione Responsabile',
                tipo_famiglia: 'Tipo Famiglia',
                flag_gest_centr: 'Gestione Centralizzata',
                data_inizio_gest_centr: 'Inizio Gestione Centralizzata',
                data_fine_gest_centr: 'Fine Gestione Centralizzata'
            }
        }
    },
    tim: {
        gettask: {
            button_label: 'Recupero informazioni Work Request',
            getting_info: 'Recupero informazioni in corso...',
            success: 'Trovata Work Request con Id: %{id}',
            success_nwfmTask: 'Trovata la Work Request con Id: %{id}, Attenzione ha data di completamento > 40gg',
            missing_workrequestid: 'Si prega di impostare il campo Id Work Request',
            minmax_workrequestid: 'Il campo deve essere compreso tra 0 e 2147483647',
            generic_error: 'Errore nell’estrazione dati da NWFM',
            wrong_nmu: "Il numero seriale TIM contiene un nmu non valido o non gestito da digigem"
        },
        getdevice: {
            button_label: 'Recupero informazioni Apparato',
            getting_info: 'Recupero informazioni in corso...',
            success: 'Trovato apparato con Serialnumber: %{id}',
            missing_serialnumber: 'Si prega di impostare il campo Serial Number TIM',
            not_found: 'Apparato non trovato'
        },
        barcodescanner: {
            success: 'Scansione avvenuta con successo, risultato %{r}',
            cancelled: "La scansione è stata annullata dall'utente",
            error: 'Scansione non riuscita: %{e}'
        },
        createrelateddevice: {
            copy: 'Copia'
        },
        sendtosap: {
            title: "Scaricare i apparati",
            content: "Sei sicuro di voler scaricare questi articoli? Verranno aggiornati solo gli apparati con stato 'Approvato'",
            button_label: 'Scarica verso SAP',
            confirm: 'conferma',
            cancel: 'annulla',
            noDevices: 'Non ci sono apparati da scaricare',
            error: 'Si è verificato un errore, controlla la consola per maggiori dettagli',
            confirm_message: 'Questo aggiornerà %{d} apparati, vuoi continuare?',
            success: "Aggiornato %{n} dispositivi"
        },
        uploadfile: {
            button_label: 'Upload File',
            error: 'Si è verificato un errore, controlla la consola per maggiori dettagli',
            export: 'Esportare',
            close: 'OK',
            invalidStatus: 'Non in Validato',
            invalidAOA: 'AOA invalido',
            dragOrClick: 'Trascina e rilascia un file qui o fai clic'
        },
        uploadFileMultipleFilter: {
            button_label: 'Upload Filtro Multiplo',
            error: 'Si è verificato un errore, controlla la consola per maggiori dettagli',
            ok: 'OK'
        },
        associazioneMassiva: {
            button_label: 'Associazione Massiva',
            error: 'Si è verificato un errore, controlla la consola per maggiori dettagli',
            cancel: 'AnnulLa',
            confirm: 'Salva',
            cr173: "Utilizzare per questa WR la nuova funzionalità Scarico OLO complessivo",
            cr173_invalidWRType: "Associazione materiale multipla non consentita per questo tipo WR e/o per questo  tipo materiale",
            cr173_invalidWR: "Non è stata identificata una workrequest associata all’impresa",
            cr173_invalidWRStatus: "Non è stata identificata una workrequest in stato compatibile con lo scarico",
            cr173_WRAssociated: "WR già associata",
            cr173_MagazziniOmogenea: "Materiale proveniente in parte da magazzini MOS e in parte da magazzini MOI",
            cr173_SerialeAssociatoAltraLavorazione: "Il Serial Number TIM risulta associato ad un’altra lavorazione",
            cr173_SerialeGiaAssociata: "Il Serial Number TIM risulta già associata",
            cr173_NoListaNMUInTask: "L'attività non ha il nmu proposto",
            caso5: "WR già associata a: %{list}",
            caso6: "La lavorazione risulta in carico ad una differente impresa-Inserire la WR corretta",
            superWifi: "È stata raggiunta la maxquantità di scarico per l’NMU",
            TO_SM_319: "Non è stata identificata una workrequest compatibile con lo scarico",
            caso3: "Il Serial Number TIM risulta attribuito ad altra Impresa",
            cr50: "Il Serial Number risulta associato ad un magazzino non di tua competenza",
            reverse: "Guasto al primo utilizzo",
            cr93_senza_consegna: "Attenzione hai selezionato una lavorazione che non prevede consegna prodotti. Vuoi continuare?",
            cr93_libero: "Attenzione hai selezionato una lavorazione che prevede router libero. Vuoi continuare?",
            cr93_non_comp: "Attenzione hai selezionato una NMU prodotto diversa o non compatibile con quella indicata nella WR. La fornitura di materiale non appropriato causa disallineamento a livello commerciale e possibili disservizi al Cliente. Vuoi continuare?",
            es037_rejectblock: "Attenzione associazione già rigettata varie volte, scaricare o addebitare il materiale",
            es037_validatewarn: "Attenzione: molteplici validazioni per la stessa associazione, non saranno possibili altre validazioni. Se l’associazione risultasse ancora errata, il materiale sarà addebitato: Continuare?",
            cr138: "Materiale a SU 3 non impiegabile per Lavorazioni Delivery",
        },
        note: {
            button_label: 'Note',
            error: 'Si è verificato un errore, controlla la consola per maggiori dettagli',
            cancel: 'Tornare indietro'
        },
        fileListDialog: {
            button_label: 'File',
            error: 'Si è verificato un errore',
            close: 'OK',
            confirmation_title: 'Attenzione',
            confirmation_message: 'Vuoi eliminare questo file?',
            confirm: 'Continuare',
            cancel: 'Tornare indietro',
            deleted: 'File cancellato'
        },
        validateregman: {
            button_label: 'Check Regman',
        },
        validateregmanbulk: {
            title: "Approvare i apparati",
            content: "Sei sicuro di voler aggiornare questi articoli? Verranno aggiornati solo gli apparati validi per il CheckRegman",
            button_label: 'Check Regman',
            confirm: 'conferma',
            cancel: 'annulla',
            export: 'Esportare',
            close: 'OK',
            notValid: 'Non abilitato al CheckRegman',
            error: 'Error updating devices'
        },
        approvedevices: {
            title: "Approvare i apparati",
            content: "Sei sicuro di voler approvare questi articoli? Verranno aggiornati solo gli apparati con stato 'Validato'",
            warning: "Attenzione se la selezione  contiene item da addebitare  devono essere approvati singolarmente e deve essere inserita la causale di abbebito Continuare?",
            button_label: 'Approva',
            confirm: 'conferma',
            cancel: 'annulla',
            export: 'Esportare',
            close: 'OK',
            notValid: 'Non in Validato',
            error: 'Error updating devices'
        },
        magmoi_enabledisable: {
            button_label_enable: ' Sblocca',
            button_label_disable: ' Blocca',
            error: 'Si è verificato un errore',
            updated: "Aggiornato"
        },
        delete: {
            title: "Cancella apparato %{name}",
            content: "Sei sicuro di voler cancellare l'item?",
            button_label: 'Cancella',
            confirm: 'conferma',
            cancel: 'annulla',
            error: 'Errore nella cancellazione del apparato',
            deleted: 'Apparato cancellato'
        },
        reset: {
            title: "Disassocia apparato %{name}",
            content: "Sei sicuro di voler disassociare l'item?",
            contentDaScaricare: "Saranno dissociate anche tutte le associazioni (tutte seriali) legate al WorkRequest che si intende dissociare",
            button_label: 'Disassocia',
            confirm: 'conferma',
            cancel: 'annulla',
            error: 'Errore nella disassociazione del apparato',
            deleted: 'Apparato disassociato'
        },
        resetCheck: {
            title: "ResetCheck apparato %{name}",
            content: "Sei sicuro di voler fare il reset dei controlli Regman e CollaudoOne?",
            button_label: 'ResetCheck',
            confirm: 'conferma',
            cancel: 'annulla',
            error: 'Errore nel reset dei controlli Regman e CollaudoOne',
            updated: 'Apparato aggiornato'
        },
        validatedevices: {
            title: 'Convalida apparati',
            content: "Sei sicuro di voler convalidare questi articoli? Verranno aggiornati solo gli apparati con stato 'Associato'",
            rejected_warning: "Attenzione: Se sono presenti ITEM con molteplici validazioni. Saranno esclusi automaticamente da questa selezione.",
            button_label: 'Valida',
            confirm: 'conferma',
            cancel: 'annulla'
        },
        dashboard: {
            welcome: "Benvenuto",
            not_auth: "Non sei autorizzato a visualizzare questa pagina. Contatta l'adiminstrator o accedi con un altro account."
        },
        digigemJsonProvider: {
            dup_key: "C'è già una voce con la stessa chiave"
        },
        validateandsave: {
            caso0a: 'Il Serial Number TIM  risulta non corretto',
            caso0b: 'NMU non gestito su DIGIGEM-MOI',
            caso1: "Il Serial Number TIM non risulta presente nella Base Dati",
            caso2: "Il Serial Number TIM risulta associato ad un’altra lavorazione",
            caso3: "Il Serial Number TIM risulta attribuito ad altra Impresa",
            caso4: "Il codice della lavorazione non è corretto",
            caso5: "WR già associata a: %{list}",
            caso6: "La lavorazione risulta in carico ad una differente impresa-Inserire la WR corretta",
            caso7: "La causale inserita non è compatibile con il tipo lavorazione",
            reverse: "Guasto al primo utilizzo",
            title: 'Attenzione',
            confirm: 'continuare',
            cancel: 'tornare indietro',
            cr50: "Il Serial Number risulta associato ad un magazzino non di tua competenza",
            superWifi: "È stata raggiunta la maxquantità di scarico per l’NMU",
            cr93_senza_consegna: "Attenzione hai selezionato una lavorazione che non prevede consegna prodotti. Vuoi continuare?",
            cr93_libero: "Attenzione hai selezionato una lavorazione che prevede router libero. Vuoi continuare?",
            cr93_non_comp: "Attenzione hai selezionato una NMU prodotto diversa o non compatibile con quella indicata nella WR. La fornitura di materiale non appropriato causa disallineamento a livello commerciale e possibili disservizi al Cliente. Vuoi continuare?",
            es037_rejectblock: "Attenzione associazione già rigettata varie volte, scaricare o addebitare il materiale",
            es037_validatewarn: "Attenzione: molteplici validazioni per la stessa associazione, non saranno possibili altre validazioni. Se l’associazione risultasse ancora errata, il materiale sarà addebitato: Continuare?",
            cr138: "Materiale a SU 3 non impiegabile per Lavorazioni Delivery",
            cr173: "Utilizzare per questa WR la nuova funzionalità Scarico OLO complessivo",
            daesaminare_collaudoOneKo: "Il CheckCollaudoOne è KO",
            daesaminare_regmanKo: "Il CheckRegman è KO", 
            cr209: 'Invierai il seguente numero di consegna: %{num_consegna}. Intendi confermare?',
            cr209_noChange: 'Non hai modificato il num_consegna. Intendi confermare?'
        },
        devices: {
            mandatory: "Questo campo è obbligatorio",
            sn_search_mandatory_1: "Devi cercare questo Serial Number TIM prima di salvare",
            sn_search_mandatory_2: "Cerca il Id Work Request per impostare questo campo",
            get_task_mandatori: "Questo campo è obbligatorio",
            ivalid_gettask: 'Questo campo non è valido',
            isvalid_num_consegna: 'Il campo deve essere numerico e lungo 10 caratteri',
            invalid_note: 'Questo campo non può contenere caratteri speciali'
        },
        disallineatobtn: {
            title: "%{name} è disallineato ?",
            content: "Sei sicuro di voler cambiare il stato dell'item?",
            button_label: 'Disallineato',
            confirm: 'conferma',
            cancel: 'annulla',
            error: 'Errore nel cambio di status',
            updated: 'Apparato aggiornato'
        }
    }
}